<template>
  <div class="">
    <ToastNotification />
    <Header />

    <div class="main-container">
      <Loader />
      <main>
        <div class="page-container">
          <router-view></router-view>
        </div>

      </main>
      <aside>

      </aside>
    </div>
    
    <Footer />
  </div>
</template>

<script>
/* eslint-disable */

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Loader from "@/components/controls/Loader.vue";
import ToastNotification from "@/components/controls/ToastNotification.vue";
import { lookupDataHelper } from "@/utils/lookupDataHelper";
import commonMixin from "@/mixins/commonMixin";
//import {} from "@/state/helpers";

export default {
  name: "app",
  mixins: [commonMixin],
  components: {
    Header,
    Footer,
    Loader,
    ToastNotification
  },
  data() {
    return {
      footerLinks: []
    }
  },
  methods: {
  },
  computed: {
  },
  mounted () {
     
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
